
// /* eslint-disable */
// import React, { useState, useEffect, useRef, useMemo, Component } from 'react'
// //Report Viewer source
// import '@boldreports/javascript-reporting-controls/Content/v2.0/tailwind-light/bold.report-viewer.min.css';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/common/bold.reports.common.min';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/common/bold.reports.widgets.min';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/bold.report-viewer.min';
// //Reports react base
// import '@boldreports/react-reporting-components/Scripts/bold.reports.react.min';

// var viewerStyle = {'height': '700px', 'width': '100%'};

// export function Reporting() {
//   const PostReportAction = (args) => {
//     if (args.action === "print") {
//         console.log("Report is being printed");
//     } else if (args.action === "clearCache") {
//         console.log("Cache cleared");
//     } else if (args.action === "export") {
//         console.log("Report is being exported");
//         // Handle export post-actions here
//     }
// };

//   return (
//     <div style={viewerStyle}>
//       <BoldReportViewerComponent
//       id="reportviewer-container"

//       reportServiceUrl = 'http://localhost:49000/ReportViewer'
// //       reportPath="SBA Fund Fact Sheet.rdl"
// //  reportServerUrl="http://awdc-sqluat/ReportS/report/Redesign"

//       >
//       </BoldReportViewerComponent>
//     </div>
//   );
// }

// export default Reporting;



// // getReportController




import React, { useState, useEffect, useRef } from "react";
import { UrlPath } from "../../config/routeConfig";
import { SBAComboBox } from "../UiComponents/SBADropDown";
import { BreadCrumbs } from "../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../shared/topBar/TopBar";
import { getDyanmicReportDataSource, getReportContent, getReportController, getreportingCategory, getreportingCategoryById, getReportPDFContent } from "../../config/apiConfig";
import { sbaAxios } from '../utils/sbaAxios';
import { SBNotify } from "../utils/sbNotify"
import { ToastContainer } from "react-toastify";
import { FileViewer, GetUIController } from "./DyanmicReportView";
import { LoadingScreen } from "../UiComponents/LoadingComponent";
import PdfRenderer from './PdfRenderer';

export const ssrsURL = process.env.REACT_APP_NEXTGEN_REPORT_SERVER_URL + "/ReportServer/Pages/ReportViewer.aspx?";
export const Reporting = () => {
    const [reportsCategory, setReportsCategory] = useState([]);
    const [reports, setReports] = useState([]);
    const [controllers, setController] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState(reportsCategory[0]);
    const [selectedReports, setSelectedReports] = useState(null);

    const [enableEnter, setEnableEnter] = useState(false);
    const [downloadingReport,setDownloadingReport]=useState(false);
    
    const [canLoadReport, setCanLoadReport] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);

    const Level = [{ BreadCrumb: "Reporting >", Routes: `/${UrlPath.Reports}` }, { BreadCrumb: "Standard Reports", Routes: `/${UrlPath.standardReports}` }];

    const childRef = useRef();

    useEffect(() => {
        document.title = "Standard Reports";
        rolesListData();
    }, []);

    useEffect(() => {
        if (selectedCategory) {
            reportCategoryId(selectedCategory.CategoryId);
        }
    }, [selectedCategory]);

    const rolesListData = async () => {
        try {
            const response = await sbaAxios({
                url: `${getreportingCategory}`,
                method: 'get',
            })
            const data = response;
            setReportsCategory(data);
            setSelectedCategory(data[0]);
        } catch (error) {
            console.error("Error fetching rolesListData from API:", error);
        }
    };

    const reportCategoryId = async (id) => {
        try {
            const response = await sbaAxios({
                url: `${getreportingCategoryById}${id}`,
                method: 'get',
            })
            const data = response;
            setReports(data);

        } catch (error) {
            console.error("Error fetching rolesListData from API:", error);
        }
    };

    const categoryDDChange = (e) => {
        if (e.value) {
            setSelectedCategory(e.value);
            setSelectedReports(null);
            setController([]);
            setCanLoadReport(false);
        }
    }

    const reportDDChange = (e) => {
        if (e.value) {
            setSelectedReports(e.value);
            setCanLoadReport(false);
            setController([]);
        }
    }
    useEffect(() => {
        const getReport = async () => {
            if (!selectedReports) {
                SBNotify({ Msg: "Please Select any Report", type: "error" });
                return;
            }
    
            try {
                const res = await sbaAxios({ url: getReportController + selectedReports?.ReportUrl });
                const result = await Promise.all(
                    res.map(async resItem => {
                        resItem.ReportUrl=selectedReports?.ReportUrl;
                        if (!resItem?.DefaultValues || !resItem?.DefaultValues[0]) {
                            resItem.DefaultValues = [];

                            if (resItem?.ValidValuesQueryBased === true ) {
                                if(!resItem.Dependencies)
                                    resItem.Dataset = await GetReportParamDataSource(selectedReports?.ReportUrl,resItem.Name,null);
                                if(resItem.ValidValues)
                                {
                                    resItem.Dataset = resItem.ValidValues;
                                    resItem.selectedValue=resItem.ValidValues.find(item=>item.Value==resItem?.DefaultValues?.[0]) || null;
                                }
                                resItem.ChildControl=res.filter(fItem=>fItem?.Dependencies?.filter(itemm=>itemm==resItem.Name)?.length>0).map(item=>item.Name);
                            }
                            else if (resItem.ParameterTypeName === "String")
                                resItem.DefaultValues[0] = "";
                            else if (resItem.ParameterTypeName === "DateTime")
                                if(resItem.Name=="StartDate")
                                    resItem.DefaultValues[0] = "01/01/2025";
                                else
                                    resItem.DefaultValues[0] = "03/31/2025";
                            else if (resItem.ParameterTypeName === "Boolean")
                                resItem.DefaultValues[0] = "False";

                        }
                        return resItem;
                    })
                );
                setController(result);
                setCanLoadReport(true);
            } catch (error) {
                setController([]);
                setCanLoadReport(true);
                SBNotify({ Msg: "Error Occurred while Fetching UI Controllers", type: "error" });
                console.error("Error fetching controller:", error);
            }
        };
    
        if (selectedReports !== null) {
            getReport();
        }
    }, [selectedReports]);
    

    const handlePdfClick = () => {
        setDownloadingReport(true);
        if (childRef.current) {
            childRef.current.triggerChildfetchPdf();
        }
    }
    const handleXlsxClick = () => {
        setDownloadingReport(true);
        if (childRef.current) {
            childRef.current.triggerChildfetchXlsx();
        }
    }
    const handlefetchReport = () => {
        setReportLoading(true);
        if (childRef.current) {
            childRef.current.triggerChildFetchReport();
        }
    }
    const handleEnableEnter = (value) => {
        setEnableEnter(value)
    }

  
    return (
        <>
            <TopBar label={"Standard Reports"} />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />
                {downloadingReport && <><LoadingScreen/></>}
                
                  <div className="" style={{ display: downloadingReport ? "none" : "unset" }}>
                    <div className="p-3">
                    <div className="row">
                    <div className="col-md-3">
                            <label className="label">Report Category</label>
                            <SBAComboBox data={reportsCategory} valueField={'CategoryId'} textField={`CategoryName`} value={selectedCategory} onChange={categoryDDChange} />
                        </div>
                        <div className="col-md-3">
                            <label className="label">Report Name</label>
                            <SBAComboBox
                                data={reports}
                                valueField={'ReportId'}
                                textField={`ReportTitle`}
                                value={selectedReports}
                                onChange={reportDDChange}
                                placeholder="Please Select Report"
                            />
                        </div>
                        <div className="col-md-3 row-items">
                            <div className="d-flex gap-2 flex-wrap justify-content-center">
                                <button className="p-sm-btn " disabled={!enableEnter} onClick={handlefetchReport}>View Report</button>
                                <button className="btn" disabled={!enableEnter} onClick={handlePdfClick}>
                                    <i class="far fa-file-pdf SBA_hand" style={{ color: "red" }}></i>
                                </button>
                                <button className="btn" disabled={!enableEnter} onClick={handleXlsxClick}>
                                    <i class="far fa-file-excel SBA_hand" style={{ color: "green" }}></i>
                                </button>
                            </div>
                        </div>
                        <div >
                        <ReportContainer
                            reportName={selectedReports}
                            controllers={controllers}
                            canLoadReport={canLoadReport}
                            reportLoading={reportLoading}
                            setEnableEnter={handleEnableEnter}
                            setReportLoading = {setReportLoading}
                            ref={childRef}
                            setDownloadingReport={setDownloadingReport}
                        />
                        </div>
                    </div>
                    </div>
                </div>
               
            </div>

            <ToastContainer />
        </>
    );
};
const ReportContainer = React.forwardRef((props, ref) => {
    const { reportName, controllers, canLoadReport, setEnableEnter, setReportLoading ,setDownloadingReport } = props;
    const [pdfStream, setPdfStream] = useState(null);

    const [controllersState, setControllerState] = useState([]);
    const [reportingLoading, setReportingLoading] = useState(props.reportLoading);
    useEffect(() => {
        setReportingLoading(props.reportLoading)
    }, [props.reportLoading]);
    useEffect(()=>{
        setPdfStream(null);
    },[canLoadReport])
    useEffect(() => {
        setEnableEnter(canLoadReport);
    }, [canLoadReport]);
    useEffect(() => {
        setControllerState(controllers);
    }, [controllers]);
    const fetchReport = async () => {
        let stream = 'response'
        try {

            const reportParams = {
                "reportName": reportName.ReportUrl,
                "format": "PDF",
                "reportParams": controllersState.map(item => {
                    if(item.ValidValuesQueryBased)
                    {
                        return {
                            "parameterName": item.Name,
                            "parameterValue": item.Name== "FundIds" ? '-1': item?.dataToPass||'1',
                            "parameterDataType": item?.ParameterTypeName
                        }
                    }
                    return {
                        "parameterName": item.Name,
                        "parameterValue": item?.DefaultValues[0],
                        "parameterDataType": "string"
                    }
                })

            };
            const response = await sbaAxios({ url: getReportContent, responseType: 'text/plain', method: 'post', data: reportParams });
            stream = response
            const frame = document.getElementById('Reportframe');
            frame.src = URL.createObjectURL(response);
            setReportLoading(false);
        } catch (error) {
            setReportLoading(false);
            console.error('Error fetching file:', error);
        }
        setPdfStream(stream)
    };
    const fetchReportPDF = async () => {
        try {

            const reportParams = {
                "reportName": reportName.ReportUrl,
                "format": "PDF",
                "reportParams": controllersState.map(item => {
                    if(item.ValidValuesQueryBased)
                    {
                        return {
                            "parameterName": item.Name,
                            "parameterValue": item?.dataToPass,
                            "parameterDataType": item?.ParameterTypeName
                        }
                    }
                    return {
                        "parameterName": item.Name,
                        "parameterValue": item?.DefaultValues[0],
                        "parameterDataType": "string"
                    }
                })
            };
            const response = await sbaAxios({ url: getReportPDFContent, responseType: 'blob', method: 'post', data: reportParams });
            const blobUrl = URL.createObjectURL(response);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = reportName.ReportTitle;
            document.body.appendChild(link);
            link.dispatchEvent(
                new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                })
            );
            document.body.removeChild(link);
            setReportLoading(false);
            setDownloadingReport(false);
        } catch (error) {
            setReportLoading(false);

            console.error('Error fetching file:', error);
        }
    };
    const fetchReportXLSX = async () => {
        try {

            const reportParams = {
                "reportName": reportName.ReportUrl,
                "format": "Excel",
                "reportParams": controllersState.map(item => {
                    if(item.ValidValuesQueryBased)
                    {
                        return {
                            "parameterName": item.Name,
                            "parameterValue": item?.dataToPass,
                            "parameterDataType": item?.ParameterTypeName
                        }
                    }

                    return {
                        "parameterName": item.Name,
                        "parameterValue": item?.DefaultValues[0],
                        "parameterDataType": item?.ParameterTypeName
                    }
                })

            };
            const response = await sbaAxios({ url: getReportPDFContent, responseType: 'blob', method: 'post', data: reportParams });
            const blobUrl = window.URL.createObjectURL(response);            
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = reportName.ReportTitle;
            document.body.appendChild(link);
            link.dispatchEvent(
                new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                })
            );
            document.body.removeChild(link);
            setDownloadingReport(false);
            setReportLoading(false);
        } catch (error) {
            setReportLoading(false);
            console.error('Error fetching file:', error);
        }
    };

    React.useImperativeHandle(ref, () => ({
        triggerChildFetchReport: fetchReport,
        triggerChildfetchPdf: fetchReportPDF,
        triggerChildfetchXlsx: fetchReportXLSX
    }));
    
    const [isPanelVisible, setIsPanelVisible] = useState(true);

  const togglePanel = () => {
        setIsPanelVisible(!isPanelVisible);
    };
    return (
        <div className="p-3">
            {canLoadReport && <>
                <div className="row  my-4">

                    <div className="splitter-container bg-white">
                        {isPanelVisible && (
                            <div className="splitter-panel bg-white">
                                <div className="col-12 col-md-10">
                                    <GetUIController list={controllersState} setList={setControllerState}></GetUIController>
                                </div>
                            </div>
                        )}
                        <button onClick={togglePanel} title={isPanelVisible? "Hide": "Show"} className="bg-white border-top mt-2 position-relative" style={{borderColor:"#2D475C" ,borderTop:'2px solid #2D475C'}}>
                            {isPanelVisible ? (
                                <>
                                    <i className="fa  fa-v position-absolute bg-white" aria-hidden="true" style={{color:"#2D475C",top:'-8px' ,transform:'rotate(180deg)',transition:'transform 0.3s',fontSize:'smaller'}}></i>
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-v position-absolute bg-white" aria-hidden="true" style={{color:"#2D475C",top:'-8px',transform:'rotate(360deg)',transition:'transform 0.3s',fontSize:'smaller'}}></i>
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {reportingLoading ? <div ><LoadingScreen /></div> :
                <div style={{ visibility: reportingLoading ? "hidden" : "visible" }}>
                    {pdfStream && <PdfRenderer pdfStream={pdfStream} fileName={reportName?.ReportTitle}></PdfRenderer>}
                </div>
                }
                </>}
        </div>
    )
});
export const GetReportParamDataSource = async (reportName, paramName, paramValue) => {
    try {
        let params = new URLSearchParams();
        if (reportName != null) params.append("sReportName", reportName);
        if (paramName != null) params.append("paramname", paramName);
        if (paramValue != null) params.append("paramValue", paramValue);

        const url = `${getDyanmicReportDataSource}?${params.toString()}`;
        const res = await sbaAxios({ url });

        const data = JSON.parse(res?.responseData || "[]");

        return data.map(item => ({
            Value: item[res.ValueField],
            Label: item[res.LabelField]
        }));
    } catch (error) {
        console.log("Error Fetching Dynamic Data", error);
        return [];
    }
}
